/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedLayout_viewer = {
    readonly buyPage: {
        readonly totalResults: number | null;
        readonly pageType: string | null;
        readonly appliedFilters: ReadonlyArray<{
            readonly name: string | null;
            readonly values: ReadonlyArray<{
                readonly displayName: string | null;
                readonly urlLabel: string | null;
                readonly code: string | null;
            } | null> | null;
        } | null> | null;
        readonly browseContentModule: {
            readonly " $fragmentRefs": FragmentRefs<"BuySharedContentModuleRegular_browseContentModule">;
        } | null;
        readonly internalBuyLinks: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"BuySharedMoreWaysToBrowse_internalBuyLinks">;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"BuySharedBreadcrumbs_buyPage" | "BuySharedTitle_buyPage" | "BuySharedResultContainer_buyPage" | "BuySharedPagination_buyPage" | "BuySharedDescription_buyPage" | "BuySharedHead_buyPage" | "BuySharedNullSearchResults_buyPage" | "BuySharedFrequentlyAskedQuestions_buyPage">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedResultContainer_viewer" | "BuySharedNullSearchResults_viewer" | "BuySharedMoreWaysToBrowse_viewer">;
    readonly " $refType": "BuySharedLayout_viewer";
};
export type BuySharedLayout_viewer$data = BuySharedLayout_viewer;
export type BuySharedLayout_viewer$key = {
    readonly " $data"?: BuySharedLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedLayout_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "page",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "rootId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "buyPage",
      "name": "itemSearch",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyPageId",
          "variableName": "rootId"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "localeOrigin",
          "variableName": "localeOrigin"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "ItemSearchQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "pageType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "appliedFilters",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "values",
              "storageKey": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "urlLabel",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "code",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "browseContentModule",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "BuySharedContentModuleRegular_browseContentModule",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "internalBuyLinks",
          "storageKey": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "BuySharedMoreWaysToBrowse_internalBuyLinks",
              "args": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedBreadcrumbs_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedTitle_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedResultContainer_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedPagination_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedDescription_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedHead_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedNullSearchResults_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedFrequentlyAskedQuestions_buyPage",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedResultContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedNullSearchResults_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedMoreWaysToBrowse_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '9697874f51f6dafe93c64de97d198fc5';
export default node;
